import {useCallback, useEffect} from "react";
import {getServerTime} from "../store/app/ActionCreators";
import {store, useAppDispatch} from "../store";
import {updateServerTime} from "../store/app/Slice";

const useServerTime = () => {
    const dispatch = useAppDispatch()

    const handleFetchServerTime = useCallback(() => {
        if (document.visibilityState === 'visible') {
            dispatch(getServerTime())
        }
    }, [dispatch])

    useEffect(() => {
        dispatch(getServerTime())
        let missingServerTimeTicks = 0

        const intervalId = setInterval(() => {
            if (document.visibilityState !== "visible") {
                return
            }

            const serverTime = store.getState().appReducer.serverTime
            if (serverTime !== null) {
                missingServerTimeTicks = 0
                dispatch(updateServerTime())
                return
            }

            missingServerTimeTicks += 1
            if (missingServerTimeTicks >= 5) {
                handleFetchServerTime()
                missingServerTimeTicks = 0
            }
        }, 1000)

        const syncIntervalId = setInterval(() => {
            handleFetchServerTime()
        }, 60000)

        document.addEventListener('visibilitychange', handleFetchServerTime);
        // window.addEventListener('focus', handleFetchServerTime);

        return () => {
            document.removeEventListener('visibilitychange', handleFetchServerTime);
            // window.removeEventListener('focus', handleFetchServerTime);
            clearInterval(intervalId)
            clearInterval(syncIntervalId)
        };
    }, [dispatch, handleFetchServerTime])
}

export default useServerTime
